import { Tag, Typography, Space } from "antd";

const { Text } = Typography;
const columns = [
  {
    title: "تاریخ ثبت",
    dataIndex: "createdAt",
    key: "createdAt",
    width: 110,
    sorter: true,
  },
  {
    title: "نام",
    dataIndex: "name",
    key: "name",
    width: 180,
    sorter: true,
    ellipsis: true,
  },
  {
    title: "دسته بندی",
    dataIndex: "packageType",
    key: "packageType",
    sorter: true,
    width:140,
    render: (_,  {packageType : cat} ) => {
      return (
      <>
            <p key={cat}>
              {cat === "WORK_SPACE"
                ? "فضای کار"
                : cat === "CLASS"
                ? "کلاس"
                : cat === "EVENT"
                ? "رویداد"
                : cat === "CONSULTATION"
                ? "مشاوره"
                : cat === "MEETING_ROOM"
                ? "اتاق جلسات"
                : "نامشخص"}
            </p>
      </>
    )
  }
  },
  {
    title: "محصول",
    dataIndex: "product",
    key: "product",
    width: 150,
    sorter: true,
    ellipsis: true,
  },
  {
    title: "روز/جلسه",
    dataIndex: "daysOrSessions",
    key: "daysOrSessions",
    width: 120,
    sorter: true,
    ellipsis: true,
  },
  {
    title: "قیمت (ریال)",
    dataIndex: "amountRial",
    key: "amountRial",
    width: 160,
    sorter: true,
    ellipsis: true,
  },
  {
    title: "توضیحات",
    dataIndex: "description",
    key: "description",
    ellipsis: true,
  },
  {
    title: "جزییات",
    dataIndex: "details",
    key: "details",
    width: 100,
  },
];

export default columns;
